import React from "react";
import 'moment/locale/es';
import { personasActions } from '../actions';
import { connect } from 'react-redux'
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import { Spinner } from 'components/Icons/Spinner';
import {
    Button,
    Row,
    Col,
  } from "reactstrap";

var personasService = require ('../api');



class UploadImageCard extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
          formData: {
            },
          formErrors: {
              isValid: false
          },

          src: null,
          crop: {
            unit: '%',
            width: 30,
            aspect: 1/1,
          },
          croppedImageUrl: null,
          isUploading: false
        }

     }

     onSelectFile = e => {
      if (e.target.files && e.target.files.length > 0) {
        const reader = new FileReader();
        reader.addEventListener('load', () =>
          this.setState({ src: reader.result })
        );
        reader.readAsDataURL(e.target.files[0]);
      }
    };

    onImageLoaded = image => {
      this.imageRef = image;
    };
  
    onCropComplete = crop => {
      this.makeClientCrop(crop);
    };
  
    onCropChange = (crop, percentCrop) => {
      // You could also use percentCrop:
      // this.setState({ crop: percentCrop });
      this.setState({ crop });
    };
  
    async makeClientCrop(crop) {
      if (this.imageRef && crop.width && crop.height) {
        const croppedImageUrl = await this.getCroppedImg(
          this.imageRef,
          crop,
          'newFile.jpeg'
        );
        this.setState({ croppedImageUrl });
      }
    }
  
    getCroppedImg(image, crop, fileName) {
      const canvas = document.createElement('canvas');
      const scaleX = image.naturalWidth / image.width;
      const scaleY = image.naturalHeight / image.height;
      canvas.width = crop.width;
      canvas.height = crop.height;
      const ctx = canvas.getContext('2d');
  
      ctx.drawImage(
        image,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        crop.width,
        crop.height
      );

      const base64Image = canvas.toDataURL('image/jpeg');
      return base64Image ;
     }
  
   saveImage = async () => {
      this.setState({ isUploading: true });

      const { croppedImageUrl } = this.state;
      // Save image 
      let data = {
            "persona_id": this.props.persona.persona_id,
            "image": croppedImageUrl
      } ;
      let img = await personasService.uploadProfileImage( this.props.token, data )

     // Update persona
      await this.props.updatePersona ( this.props.token, 
                            this.props.persona.persona_id , { "image": img.file_url }, this.props.isMyProfile )
                         
      // Send new image to state for correct display
      this.props.persona.image = img.file_url;
      
      // let newProfileImage = {
      //         "image_id": img.id,
      //         "persona_id": this.props.persona.persona_id,
      //         "file_url": img.file_url ,
      //         "thumbnail_url": null,
      //         "image_type": "PROFILE",
      //         "upload_dt": new Date(),
      //         "status": "A",
      //         "title": "Foto de perfil NUEVA",
      //         "description": null
      //     }

      // TODO: FIXME ESTO ES PARA CUANDO HAY MULKTIPLES IMAGENES
      // let imgs = this.props.persona.images ;
      // imgs.unshift(newProfileImage);
   
      // this.props.updateProfileImages(imgs);

      // this.props.persona.images.push(newProfileImage);
      ///


      // close modal
      this.props.cancel();
    }

    handleInputChange = (event) => {
      this.setState({ formData : { ...this.state.formData, [event.target.name]: event.target.value} });
    }
    render() {
      const { crop, src } = this.state;
        return (
        <>
        
            <Row>
              <Col className="pr-1" md="8">
                <h5 className="title">Subir imagen de perfil</h5>
              </Col>
              <Col className="ml-auto text-right" md="4">
                      <Button color="default" size="sm"
                         onClick={ this.props.cancel} 
                        > X
                         
                      </Button>
              </Col>
            </Row>

            {src ? (
              <>
              <Row>
                <Col className="pr-1" md="12">
                  <ReactCrop
                    width='300' 
                    src={src}
                    crop={crop}
                    ruleOfThirds
                    circularCrop
                    onImageLoaded={this.onImageLoaded}
                    onComplete={this.onCropComplete}
                    onChange={this.onCropChange}
                  />
                </Col>
                {/* <Col className="pr-1" md="6">
                  {croppedImageUrl && (
                  <img alt="Crop" style={{ maxWidth: '100%' }} src={croppedImageUrl} />
                  )}
                </Col> */}
              </Row>
              <Row>
                <Col className="ml-auto text-right" md="12">
                  <Button
                                color="secondary"
                                disabled={this.state.isUploading}
                                type="button"
                                onClick={() => this.saveImage()}
                              >
                                {this.state.isUploading?<Spinner />:"Grabar" }
                              </Button>
                </Col>
              </Row>
              </>
              ): 
              <input type="file" accept="image/*" onChange={this.onSelectFile} />
              }

        </>
          );
       
        }
    }

const mapStateToProps = state => {

  return {
      token: state.auth.session.jwt_token,
      view: state.view,
      // persona: state.students.student.persona,
      // user: state.auth.session.user,
      isEditing: state.view.loadingModules.editingPersonaDataCard
   }
}


const mapDispatchToProps = dispatch => {
  return { 
    updateProfileImages: (imgs) => {
      dispatch(personasActions.dispatchUpdateProfileImages(imgs));
    } 
    // switchEdit: ( bool ) => {
    //     dispatch(viewActions.isLoadingModule('editingPersonaDataCard', bool));
    // }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UploadImageCard);

